export { ReactComponent as ErrorTriangle } from './svgs/error-triangle.svg';
